export class CivilCaseConstants {
    public static NO_NC_BARNUMBER = 'No North Carolina State Bar number is recorded';
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/civil/civil-case-constants.ts